import { render } from "./post-card.vue?vue&type=template&id=5272761c"
import script from "./post-card.vue?vue&type=script&lang=js"
export * from "./post-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__